import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { reportsService, ReportQueryParams } from '../services/reports.service';

// The list of reports does not change while the app is open
export const useReportCatalogue = () => {
  return useQuery({
    queryKey: ['reports', 'catalogue'],
    queryFn: () => reportsService.getCatalogue(),
    staleTime: Infinity,
  });
};

export const useReport = (key: string | null, params: ReportQueryParams) => {
  return useQuery({
    queryKey: ['reports', 'run', key, params],
    queryFn: () => reportsService.runReport(key as string, params),
    enabled: !!key,
    placeholderData: keepPreviousData,
  });
};
